

<div class="columns-data">
    <div class="header">
        {{questionData?.question | questionTitle}}
    </div>
    <div class="cube pointer" *ngFor="let c of recipients$(),let i = index" [ngClass]="{'bottom':i+1==recipients$()?.length}"
        (click)="viewSubmission(c)">
        <que-answer-by-recipient [recipient]="c" [answersByRecipient]="questionData?.recipients"
            [isTextFree]="questionData?.question?.type?.id==5" [question]="questionData?.question"
            [questionSource]="questionData?.questionSource" class="answer"></que-answer-by-recipient>
    </div>
</div>
<ng-template #empty>
    <div>--</div>
</ng-template>